import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.ACCOUNT_MAP);

export const accountOptionsSelector = ({ administration }) =>
  administration[adminPageNames.ACCOUNT_MAP].accounts;

export const bsmAccountOptionsSelector = createSelector(
  ({ administration }) => administration[adminPageNames.ACCOUNT_MAP].entities,
  accountMap => accountMap
    .map(({ bsmAccount }) => bsmAccount)
    .filter((value, idx, values) => values.indexOf(value) === idx)
    .map(value => ({ value, label: value }))
);

export const isFetchingInitialDataForAddAndEditModalSelector = ({ administration }) =>
  administration[adminPageNames.ACCOUNT_MAP].isFetchingInitialDataForAddAndEditModal;
